import {useQuery} from '@tanstack/react-query';
import {supabase} from '@/services/supabase';

export interface GameInstance {
    id: string;
    name: string;
    display_name: string;
    description?: string;
    url: string;
    thumbnail?: string;
    supabase_url: string;
    active: boolean;
    created_at: string;
    updated_at: string;
}

export const useGameInstances = () => {
    return useQuery({
        queryKey: ['game-instances'],
        queryFn: async (): Promise<GameInstance[]> => {
            const {data, error} = await supabase
                .from('game_instances')
                .select('*')
                .eq('active', true)
                .order('display_name');

            if (error) {
                console.error('Error fetching game instances:', error);
                throw error;
            }

            return data || [];
        },
    });
};
